import { ChevronLeftIcon } from '@heroicons/react/24/solid';
import { useState } from 'react';
import { useSearchParams } from 'react-router-dom';
import { useFirmContext } from '../../../../providers/FirmProvider';
import FirmAtosaIntegrationOverview from './atosa/FirmAtosaIntegrationOverview';
import FirmIntegrationsGrid from './FirmIntegrationsGrid';
import FirmFYIIntegrationOverview from './fyi/FirmFYIIntegrationOverview';

function FirmIntegrationsContainer(): JSX.Element {
    const [params, setSearchParams] = useSearchParams();
    const [focusedIntegration, setFocusedIntegration] = useState<string | undefined>(params.get('focusedIntegration') || undefined);
    const { allowedIntegrations = [] } = useFirmContext();
    function handleIntegrationClick(id: string): void {
        setFocusedIntegration(id);
        setSearchParams((prev) => {
            prev.set('focusedIntegration', id);
            return prev;
        });
    }

    function resetFocusedIntegration(): void {
        setFocusedIntegration(undefined);
        setSearchParams((prev) => {
            prev.delete('focusedIntegration');
            return prev;
        });
    }

    return (
        <>
            {focusedIntegration === undefined && <FirmIntegrationsGrid onCardSelect={handleIntegrationClick} />}
            {focusedIntegration && (
                <div>
                    <button className="text-sm text-gray-600 flex items-center gap-1 mb-8" onClick={resetFocusedIntegration}>
                        <ChevronLeftIcon className="h-4 w-4" />
                        Integrations
                    </button>
                    <FirmFYIIntegrationOverview show={focusedIntegration === 'fyi'} />
                    <FirmAtosaIntegrationOverview show={focusedIntegration === 'atosa' && allowedIntegrations?.includes('atosa')} />
                </div>
            )}
        </>
    );
}

export default FirmIntegrationsContainer;
